<template>
  <div id="map"></div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";

import { getSpecimenNumberPrefix } from "@/api/specimen";
import Utils from "@/utils/index";

import L from "leaflet";
import "leaflet.markercluster/dist/leaflet.markercluster.js";
import { GestureHandling } from "leaflet-gesture-handling";

export default {
  data() {
    return {
      map: null,
      specimenNumberPrefix: "",
    };
  },

  computed: {
    // 取得標本座標資料
    markers() {
      return this.$store.state.search.map.specimenMarkers;
    },
  },

  async mounted() {
    L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);

    this.map = L.map("map", {
      center: [24, 121],
      zoom: 7,
      zoomAnimation: false,
      scrollWheelZoom: false,
      layers: [
        L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png", {
          attribution:
            '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        }),
      ],
      gestureHandling: true,
    });

    this.specimenNumberPrefix = await getSpecimenNumberPrefix()
      .then((response) => {
        return response.data.prefix;
      })
      .catch((error) => {
        console.log("err", error.response);
      });
  },

  methods: {
    updateMarkers() {
      if (this.markers && this.markers.length !== 0) {
        // 支援 marker cluster 功能
        const clusterLayer = L.markerClusterGroup();

        for (const marker of this.markers) {
          if (marker.latlng[0] !== null && marker.latlng[1] !== null) {
          // 將標本 marker 加至 marker cluster group 層
            clusterLayer.addLayer(
              L.marker(marker.latlng).bindPopup(
                "<a href='specimen/" +
                marker.specimenId +
                "'>" +
                this.getSpecimenCatalogNumber(marker.catalogNumber) +
                (marker.title !== "" ? " - " + marker.title : "") +
                "</a>"
              )
            );
          }
        }

        // 將 marker cluster group 層加至地圖
        this.map.addLayer(clusterLayer);

        // 地圖顯示範圍包含所有標本
        this.map.fitBounds(clusterLayer.getBounds());
      }
    },

    getSpecimenCatalogNumber(catalogNumber) {
      return this.specimenNumberPrefix + Utils.pad(catalogNumber, 6);
    },
  },
};
</script>

<style>
#map {
  height: 500px;
}
</style>
